"use client";

import { motion } from "framer-motion";

interface WorkHeadingProps {
  title: string;
}

export function WorkHeading({ title }: WorkHeadingProps) {
  return (
    <motion.h1
      data-cy="work-heading"
      className="text-4xl md:text-5xl font-bold mb-6 text-[#ff88ff]"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {title}
    </motion.h1>
  );
}